
import React from 'react';

const Add = props => {
  const { color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 19 19">
      <g id="Group_36" data-name="Group 36" transform="translate(-1632 -369)">
        <line id="Line_42" data-name="Line 42" y2="16" transform="translate(1641.5 370.5)" fill="none" stroke={color} strokeLinecap="round" strokeWidth="3" />
        <line id="Line_43" data-name="Line 43" y2="16" transform="translate(1649.5 378.5) rotate(90)" fill="none" stroke={color} strokeLinecap="round" strokeWidth="3" />
      </g>
    </svg>
  );
};

export default Add;
